var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 24,
    viewBox: "0 0 396 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_7358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.742 15.2698C134.586 15.3819 108.983 15.2698 84.2332 15.1578C57.3791 15.0355 29.8335 14.9133 2.36919 15.0864C1.58624 15.4634 0.793118 15.8301 0 16.1968C28.2371 16.0033 56.5859 16.1255 84.2129 16.2477C108.972 16.3598 134.576 16.4718 159.742 16.3598C160.23 16.3598 160.627 16.1153 160.627 15.8097C160.627 15.5143 160.22 15.2698 159.732 15.2698H159.742Z",
    fill: "url(#paint0_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.868 15.3312C385.862 15.2905 375.826 15.2497 366.034 15.1988C352.775 15.1377 339.068 15.0664 325.585 15.0358C301.639 14.9747 254.265 14.9747 229.079 15.2497C228.591 15.2497 228.194 15.5044 228.204 15.81C228.204 16.1054 228.611 16.3499 229.099 16.3499H229.119C254.296 16.0749 301.649 16.0749 325.585 16.136C339.068 16.1665 352.775 16.2379 366.024 16.299C375.857 16.3499 385.943 16.4008 396 16.4314C395.949 16.0647 395.908 15.7081 395.868 15.3414V15.3312Z",
    fill: "url(#paint1_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.045 5.97963C200.821 5.93888 199.255 5.28693 198.381 4.70628C196.469 3.34126 194.72 0 194.629 0C194.548 0 192.819 3.34126 190.907 4.71647C190.033 5.28693 188.457 5.95925 188.233 5.98981C192.097 5.48048 194.578 10.2581 194.659 10.2581C194.741 10.2581 197.588 5.41935 201.035 5.98981L201.045 5.97963Z",
    fill: "url(#paint2_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.362 4.31927C157.24 4.42114 157.139 4.523 157.057 4.62487C156.081 5.82691 156.315 7.10025 157.179 8.23098C157.362 8.57733 157.657 8.93387 158.084 9.28022C158.837 9.88124 159.925 10.4823 161.165 10.9814C161.481 11.124 161.796 11.2463 162.121 11.3685C161.328 11.2972 160.576 11.1953 159.854 11.0323C159.538 10.9203 159.244 10.8082 158.959 10.686C158.928 10.6554 158.888 10.6249 158.827 10.6045C158.786 10.5943 158.756 10.5841 158.715 10.5638C158.461 10.4415 158.217 10.2989 157.993 10.1563C156.6 9.23947 155.237 7.96613 155.298 6.67241C155.339 5.73523 156.183 4.92029 157.342 4.30908L157.362 4.31927ZM153.509 6.76409C153.753 7.62996 154.637 8.35322 155.502 9.05611C155.898 9.3719 156.285 9.71825 156.712 10.0239C156.152 9.80993 155.593 9.59601 155.075 9.34134C154.017 8.82182 152.258 7.62996 153.509 6.76409ZM160.901 11.9593C160.738 11.9491 160.576 11.9288 160.413 11.9084C159.091 11.7556 157.79 11.5111 156.63 11.0731C155.837 10.7777 154.16 9.95255 154.017 9.27003C154.332 9.45339 154.668 9.62657 155.024 9.78956C156.641 10.523 158.257 11.1138 160.037 11.4602C160.84 11.7047 161.714 11.888 162.619 12.0306C162.101 12.0306 161.572 12.0103 161.043 11.9695C160.993 11.9593 160.942 11.9491 160.891 11.9593H160.901Z",
    fill: "url(#paint3_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.697 15.7691C163.647 15.3209 162.579 14.6588 162.965 14.18C163.047 14.3532 163.077 14.5365 163.24 14.7097C163.433 14.9236 163.647 15.0968 163.992 15.219C164.613 15.4431 165.701 15.5552 166.341 15.3413C166.443 15.3107 166.463 15.2394 166.372 15.1885C165.853 14.8931 165.619 14.6486 165.64 14.2105C165.65 13.7929 165.935 13.4567 166.321 13.1307C166.961 12.5908 167.999 12.0306 169.005 11.7555C170.002 11.4805 171.11 11.2462 172.198 11.2156C172.94 11.1953 173.693 11.3277 174.415 11.1749C174.527 11.1545 174.527 11.0628 174.445 11.0221C174.415 11.0017 174.374 10.9813 174.344 10.961C174.293 10.9304 174.242 10.9406 174.201 10.961C173.805 10.7878 173.083 10.798 172.656 10.7572C171.751 10.6757 170.825 10.7369 169.931 10.8184C167.948 11.0221 166.118 11.5925 164.328 12.1223C163.392 12.3973 162.386 12.6723 161.359 12.7437C160.372 12.815 159.427 12.9678 158.43 12.9983C157.383 13.0289 156.265 13.0594 155.227 12.9779C154.078 12.8761 153.184 12.652 152.289 12.2038C152.207 12.163 152.065 12.2038 152.055 12.2649C152.045 12.5399 152.38 12.7742 152.635 12.9779C153.051 13.3141 153.539 13.5892 154.089 13.854C155.177 14.3735 156.234 14.7912 157.617 14.9134C158.166 14.9644 158.715 15.0051 159.274 14.9644C159.62 14.9338 159.864 14.8217 160.108 14.9746C160.301 15.0968 160.23 15.27 160.24 15.4431C160.261 15.9932 160.271 16.4007 159.712 16.8591C159.295 17.1953 158.847 17.4907 158.39 17.8065C158.329 17.8472 158.359 17.9287 158.451 17.9389C159.01 18.051 159.884 17.7657 160.393 17.6537C161.237 17.4601 162.132 17.2156 162.813 16.8489C163.321 16.5739 163.769 16.197 163.718 15.7691H163.697Z",
    fill: "url(#paint4_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.582 17.2767C193.47 16.9304 192.677 16.9406 192.545 17.2564C191.752 17.0221 191.02 16.4924 190.501 16.146C189.738 15.6469 189.26 14.944 189.423 14.2411C189.576 13.5993 190.287 12.927 191.091 12.5093C191.579 12.2547 192.057 12.1324 192.697 12.1426C193.002 12.1426 193.836 12.163 194.182 12.326C193.836 12.3464 193.765 12.5908 194.06 12.8149C194.558 13.1919 195.382 13.0289 195.738 12.6316C196.205 12.1121 195.941 11.3684 195.3 10.9508C195.127 10.8387 194.924 10.747 194.69 10.6655C194.009 10.2479 193.053 9.95247 192.097 9.96266C190.735 9.96266 189.565 10.4822 188.803 11.1443C187.949 11.888 187.471 12.6621 187.532 13.5688C187.593 14.618 188.315 15.4126 189.128 16.309C189.179 16.3599 189.271 16.3701 189.342 16.3498C189.871 16.8795 190.582 17.5009 191.528 17.6842C191.985 17.7759 193.765 17.7861 193.592 17.2666L193.582 17.2767ZM188.559 11.7453C189.24 10.9915 190.226 10.309 191.691 10.1766C192.402 10.1155 193.135 10.2275 193.755 10.4516C193.246 10.3701 192.718 10.3498 192.27 10.4109C189.535 10.7878 188.457 12.5603 188.254 14.1087C188.203 14.455 188.254 14.781 188.386 15.0968C188.162 14.7912 187.979 14.4856 187.898 14.1494C187.695 13.2835 187.867 12.5195 188.559 11.7555V11.7453Z",
    fill: "url(#paint5_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.988 19.6199C196.988 19.6199 195.117 21.7591 193.592 20.3126C192.189 18.9781 192.077 17.7965 186.566 14.3533C186.667 14.3533 186.759 14.282 186.678 14.2107C186.281 13.8949 185.966 13.5893 185.63 13.243C185.366 12.9679 185.03 12.7235 184.603 12.5401C183.729 12.153 182.661 11.8474 181.675 11.5927C179.712 11.0732 177.658 10.8389 175.533 10.9306C173.276 11.0223 171.202 11.6844 169.524 12.591C168.629 13.0698 167.816 13.6097 167.185 14.2209C166.982 14.4246 166.626 14.7099 166.779 14.9442C166.606 15.1581 166.463 15.372 166.382 15.5961C166.118 16.3499 166.331 17.1139 166.86 17.7965C167.002 18.0409 167.206 18.2752 167.5 18.4993C167.633 18.6012 167.775 18.6929 167.907 18.7846C168.019 18.8661 168.141 18.9476 168.263 19.0189C168.294 19.0392 168.324 19.0392 168.355 19.0392C171.029 20.445 174.801 20.2311 175.503 18.7642C176.276 17.1343 173.479 16.5537 172.412 17.4297C172.412 17.4297 171.791 17.664 172.117 18.0613C172.442 18.4688 170.937 18.4993 170.388 17.7557C169.839 17.0121 168.721 15.3211 174.7 13.8746C181.055 12.3364 188.172 13.3754 191.182 20.8321C194.182 28.2888 200.018 20.3839 196.998 19.6199H196.988ZM174.069 11.827C173.815 11.8066 169.839 12.3669 167.755 14.0172C167.541 14.1903 167.328 14.3737 167.124 14.5571C167.399 14.1903 168.131 13.6912 168.294 13.5791C169.016 13.0698 169.849 12.591 170.754 12.2039C172.473 11.4705 174.252 11.0834 176.347 11.0732C178.319 11.063 180.19 11.3482 181.98 11.8576C182.865 12.1123 183.871 12.3771 184.624 12.7642C185.102 13.0087 185.386 13.3347 185.671 13.6606C185.824 13.8338 186.007 13.9764 186.2 14.119C185.834 13.9051 185.457 13.6912 185.051 13.4773C181.217 11.4807 177.211 11.3482 174.059 11.8168L174.069 11.827Z",
    fill: "url(#paint6_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.372 15.7689C189.22 15.7791 189.067 15.7587 188.925 15.6976C188.925 15.6874 188.904 15.667 188.884 15.6568C188.813 15.6263 188.742 15.5957 188.67 15.5753C188.284 15.3512 187.979 14.9743 187.806 14.7706C187.46 14.3733 187.084 13.9455 187.074 13.4972C187.054 13.049 187.176 12.5397 187.45 12.1118C187.674 11.7553 188.304 11.3275 188.955 11.246C188.996 11.1645 189.057 11.0932 189.138 11.032C188.243 10.92 187.379 10.9913 186.698 11.3988C186.088 11.7757 185.844 12.3054 185.925 12.8249C186.017 13.4259 186.149 14.1186 186.688 14.6483C186.962 14.9234 187.318 15.1577 187.705 15.3716C187.918 15.4938 188.152 15.5753 188.376 15.6568C188.65 15.8504 188.986 15.993 189.403 15.9522C189.596 15.9319 189.565 15.7485 189.362 15.7587L189.372 15.7689Z",
    fill: "url(#paint7_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.508 13.8134C191.752 13.7319 191.965 13.5689 192.077 13.4467C192.464 13.0087 192.169 12.6623 191.67 12.316C191.691 12.2956 191.691 12.265 191.65 12.2345C191.426 12.0715 190.633 12.0613 190.745 12.3567C190.766 12.4077 190.877 12.4586 190.928 12.4993C191.04 12.5706 191.132 12.6623 191.233 12.7438C191.487 12.9985 191.701 13.3856 191.396 13.6199C191.365 13.6403 191.335 13.6606 191.294 13.681C191.569 13.3856 191.467 12.9577 190.786 12.9374C189.739 12.8966 189.433 13.6606 189.189 14.1292C189.128 14.2413 189.403 14.3126 189.464 14.2005C189.556 14.0273 189.627 13.8338 189.759 13.6708C189.871 13.4671 190.094 13.3041 190.41 13.1818C191.081 13.3652 191.243 13.5384 190.898 13.7014C190.816 13.7523 190.888 13.8134 190.959 13.844C191.091 13.8949 191.233 13.8847 191.376 13.8644C191.406 13.8644 191.447 13.8644 191.477 13.844C191.477 13.844 191.498 13.844 191.508 13.8338V13.8134Z",
    fill: "url(#paint8_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.637 12.3771C160.637 12.3771 154.882 13.0596 152.98 11.6742C151.079 10.2888 152.512 9.84061 152.95 10.1971C153.387 10.5435 154.983 12.5707 160.627 12.3873L160.637 12.3771Z",
    fill: "url(#paint9_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.355 6.67248C234.416 7.9662 233.054 9.23954 231.661 10.1563C231.437 10.299 231.203 10.4314 230.939 10.5638C230.898 10.574 230.868 10.5944 230.827 10.6046C230.766 10.6249 230.725 10.6555 230.695 10.6861C230.42 10.8185 230.115 10.9305 229.8 11.0324C229.068 11.1954 228.326 11.3075 227.532 11.3686C227.858 11.2463 228.173 11.1139 228.488 10.9815C229.739 10.4823 230.827 9.88131 231.569 9.28029C231.996 8.93394 232.301 8.58759 232.474 8.23105C233.349 7.10032 233.572 5.81679 232.596 4.62494C232.515 4.52307 232.413 4.4212 232.291 4.31934C233.45 4.93054 234.294 5.74548 234.335 6.68266L234.355 6.67248ZM234.589 9.33122C234.081 9.58589 233.521 9.79981 232.952 10.0137C233.379 9.69794 233.766 9.36178 234.162 9.04599C235.026 8.34311 235.911 7.61985 236.155 6.75397C237.406 7.61985 235.647 8.8117 234.589 9.33122ZM228.61 11.9696C228.082 12.0103 227.553 12.0307 227.034 12.0307C227.939 11.8881 228.814 11.7047 229.617 11.4603C231.396 11.1139 233.013 10.5231 234.63 9.78962C234.986 9.62664 235.321 9.45346 235.636 9.2701C235.504 9.95261 233.816 10.7879 233.023 11.0732C231.864 11.501 230.563 11.7557 229.241 11.9085C229.078 11.9288 228.915 11.939 228.753 11.9594C228.702 11.9594 228.651 11.9594 228.6 11.9696H228.61Z",
    fill: "url(#paint10_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.882 16.8493C227.563 17.216 228.458 17.4605 229.302 17.6541C229.81 17.7763 230.684 18.0513 231.244 17.9393C231.325 17.9189 231.366 17.8476 231.305 17.8069C230.857 17.4911 230.4 17.1957 229.983 16.8595C229.424 16.4011 229.434 15.9936 229.454 15.4435C229.454 15.2704 229.393 15.1074 229.586 14.9749C229.83 14.8221 230.074 14.9342 230.42 14.9648C230.979 15.0055 231.528 14.9648 232.077 14.9138C233.46 14.7916 234.518 14.3637 235.606 13.8544C236.155 13.5895 236.643 13.3145 237.06 12.9783C237.314 12.7746 237.65 12.5301 237.639 12.2653C237.639 12.194 237.487 12.1634 237.406 12.2041C236.501 12.6524 235.616 12.8765 234.467 12.9783C233.43 13.07 232.311 13.0293 231.264 12.9987C230.268 12.9682 229.322 12.8154 228.336 12.744C227.298 12.6727 226.302 12.3977 225.366 12.1227C223.577 11.5929 221.747 11.0225 219.774 10.8187C218.879 10.7271 217.954 10.6761 217.049 10.7576C216.622 10.7984 215.89 10.7882 215.503 10.9614C215.463 10.941 215.402 10.941 215.361 10.9614C215.33 10.9817 215.29 11.0021 215.259 11.0225C215.178 11.0632 215.188 11.1549 215.29 11.1753C216.012 11.3281 216.754 11.1957 217.506 11.216C218.594 11.2466 219.703 11.4809 220.699 11.7559C221.706 12.031 222.733 12.5912 223.384 13.1311C223.78 13.4571 224.055 13.7933 224.065 14.2109C224.085 14.649 223.851 14.8935 223.333 15.1889C223.241 15.2398 223.272 15.3111 223.363 15.3417C224.014 15.5658 225.092 15.4435 225.712 15.2194C226.058 15.0972 226.271 14.924 226.465 14.7101C226.627 14.5369 226.648 14.3536 226.739 14.1804C227.126 14.6592 226.058 15.3213 226.007 15.7695C225.956 16.1974 226.404 16.5845 226.912 16.8493H226.882Z",
    fill: "url(#paint11_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.157 17.6947C199.103 17.5113 199.814 16.89 200.343 16.3602C200.414 16.3806 200.506 16.3704 200.557 16.3195C201.37 15.4129 202.082 14.6285 202.153 13.5793C202.214 12.6726 201.736 11.8984 200.882 11.1548C200.119 10.5029 198.95 9.98333 197.588 9.97314C196.632 9.97314 195.676 10.2584 194.995 10.676C194.761 10.7575 194.547 10.8594 194.385 10.9613C193.744 11.3687 193.48 12.1226 193.947 12.6421C194.303 13.0394 195.127 13.2023 195.625 12.8254C195.92 12.6013 195.849 12.3568 195.503 12.3365C195.849 12.1735 196.683 12.1531 196.988 12.1531C197.628 12.1531 198.106 12.2652 198.594 12.5198C199.397 12.9375 200.109 13.5996 200.262 14.2516C200.424 14.9545 199.947 15.6574 199.184 16.1565C198.665 16.4927 197.923 17.0326 197.14 17.2669C197.008 16.9511 196.215 16.9511 196.103 17.2872C195.93 17.8068 197.71 17.7864 198.167 17.7049L198.157 17.6947ZM201.777 14.1395C201.695 14.4757 201.512 14.7915 201.289 15.0869C201.421 14.7711 201.472 14.4451 201.421 14.0988C201.218 12.5504 200.14 10.7881 197.404 10.401C196.957 10.3399 196.428 10.3602 195.92 10.4417C196.54 10.2176 197.262 10.1056 197.984 10.1667C199.448 10.2991 200.435 10.9816 201.116 11.7355C201.807 12.5096 201.98 13.2635 201.777 14.1293V14.1395Z",
    fill: "url(#paint12_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.503 20.8219C201.502 13.3652 208.62 12.3261 214.985 13.8643C220.964 15.3108 219.856 17.012 219.297 17.7455C218.737 18.4789 217.243 18.4483 217.568 18.0511C217.893 17.6436 217.273 17.4195 217.273 17.4195C216.205 16.5332 213.399 17.1139 214.182 18.7539C214.884 20.2208 218.656 20.4348 221.33 19.029C221.361 19.029 221.391 19.029 221.422 19.0086C221.544 18.9373 221.666 18.8558 221.778 18.7743C221.92 18.6826 222.052 18.591 222.184 18.4891C222.479 18.265 222.683 18.0307 222.825 17.7862C223.354 17.1037 223.567 16.3397 223.303 15.5859C223.221 15.3618 223.089 15.1478 222.906 14.9339C223.059 14.6894 222.703 14.4042 222.5 14.2107C221.869 13.5893 221.045 13.0596 220.161 12.5808C218.483 11.6742 216.409 11.012 214.151 10.9203C212.016 10.8287 209.962 11.0629 208.01 11.5825C207.024 11.8473 205.956 12.1427 205.081 12.5298C204.654 12.7234 204.329 12.9577 204.054 13.2327C203.719 13.5791 203.393 13.8847 203.007 14.2005C202.926 14.2616 203.017 14.3329 203.119 14.3431C197.608 17.7862 197.496 18.9679 196.093 20.3023C194.568 21.7489 192.697 19.6096 192.697 19.6096C189.677 20.3635 195.503 28.2786 198.513 20.8219H198.503ZM204.614 13.4772C204.207 13.6911 203.821 13.9051 203.465 14.119C203.658 13.9764 203.841 13.8337 203.993 13.6606C204.288 13.3346 204.573 13.0086 205.041 12.7641C205.793 12.377 206.8 12.102 207.684 11.8575C209.474 11.3482 211.345 11.0629 213.318 11.0731C215.412 11.0833 217.192 11.4806 218.91 12.2039C219.825 12.591 220.649 13.0596 221.371 13.5791C221.534 13.7013 222.266 14.1903 222.54 14.557C222.337 14.3635 222.123 14.1801 221.91 14.0171C219.815 12.3567 215.839 11.8066 215.595 11.827C212.443 11.3482 208.437 11.4806 204.604 13.4874L204.614 13.4772Z",
    fill: "url(#paint13_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.303 15.7694C200.455 15.7796 200.608 15.7592 200.75 15.6981C200.75 15.6879 200.77 15.6675 200.791 15.6573C200.862 15.6268 200.933 15.5962 201.004 15.5758C201.391 15.3517 201.696 14.9748 201.869 14.7711C202.214 14.3738 202.59 13.9459 202.601 13.4977C202.621 13.0495 202.499 12.5402 202.224 12.1123C202.001 11.7558 201.37 11.3279 200.72 11.2465C200.679 11.165 200.618 11.0937 200.537 11.0325C201.431 10.9205 202.296 10.9918 202.977 11.3993C203.587 11.7762 203.831 12.3059 203.75 12.8254C203.658 13.4264 203.526 14.1191 202.987 14.6488C202.713 14.9239 202.357 15.1582 201.97 15.3721C201.757 15.4943 201.523 15.5758 201.299 15.6573C201.025 15.8509 200.689 15.9935 200.272 15.9527C200.079 15.9324 200.109 15.749 200.313 15.7592L200.303 15.7694Z",
    fill: "url(#paint14_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.198 13.8239C198.198 13.8239 198.269 13.8442 198.299 13.8442C198.431 13.8748 198.574 13.8748 198.716 13.8239C198.787 13.7933 198.858 13.7322 198.777 13.6813C198.431 13.5183 198.594 13.3451 199.265 13.1617C199.58 13.284 199.794 13.447 199.916 13.6507C200.048 13.8239 200.119 14.0072 200.211 14.1804C200.272 14.2925 200.546 14.2212 200.485 14.1091C200.241 13.6405 199.946 12.8765 198.889 12.9173C198.208 12.9478 198.106 13.3757 198.381 13.6609C198.35 13.6405 198.309 13.6201 198.279 13.5998C197.974 13.3655 198.187 12.9784 198.442 12.7237C198.543 12.6422 198.635 12.5607 198.747 12.4792C198.797 12.4385 198.909 12.3977 198.93 12.3366C199.041 12.031 198.238 12.0514 198.025 12.2144C197.984 12.2449 197.984 12.2755 198.004 12.2959C197.506 12.632 197.221 12.9886 197.598 13.4266C197.709 13.5488 197.923 13.7118 198.167 13.7933C198.167 13.7933 198.187 13.8035 198.198 13.8035V13.8239Z",
    fill: "url(#paint15_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.038 12.3771C229.038 12.3771 234.793 13.0596 236.695 11.6742C238.596 10.2888 237.162 9.84061 236.725 10.1971C236.288 10.5537 234.692 12.5707 229.048 12.3873L229.038 12.3771Z",
    fill: "url(#paint16_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.721 23.1546C192.9 23.1546 191.426 22.2479 191.426 21.1376C191.426 20.0272 192.9 19.1206 194.721 19.1206C196.541 19.1206 198.015 20.0272 198.015 21.1376C198.015 22.2479 196.541 23.1546 194.721 23.1546Z",
    fill: "url(#paint17_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.457 13.1106C185.457 13.1106 175.035 6.78461 164.613 10.5435C164.613 10.5435 175.035 4.76763 185.457 13.1106Z",
    fill: "url(#paint18_linear_422_7358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.831 13.467C203.831 13.467 214.254 7.14106 224.676 10.9C224.676 10.9 214.254 5.12408 203.831 13.467Z",
    fill: "url(#paint19_linear_422_7358)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_422_7358",
    x1: 0,
    y1: 15.7078,
    x2: 160.627,
    y2: 15.7078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_422_7358",
    x1: 228.194,
    y1: 15.7183,
    x2: 396,
    y2: 15.7183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_422_7358",
    x1: 188.243,
    y1: 5.12394,
    x2: 201.045,
    y2: 5.12394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_422_7358",
    x1: 153.092,
    y1: 8.18005,
    x2: 162.64,
    y2: 8.18005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_422_7358",
    x1: 152.045,
    y1: 14.343,
    x2: 174.496,
    y2: 14.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_422_7358",
    x1: 187.522,
    y1: 13.854,
    x2: 195.971,
    y2: 13.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_422_7358",
    x1: 166.27,
    y1: 17.4501,
    x2: 197.832,
    y2: 17.4501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_422_7358",
    x1: 185.905,
    y1: 13.4667,
    x2: 189.545,
    y2: 13.4667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_422_7358",
    x1: 189.179,
    y1: 13.1818,
    x2: 192.25,
    y2: 13.1818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_422_7358",
    x1: 152.034,
    y1: 11.3075,
    x2: 160.637,
    y2: 11.3075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_422_7358",
    x1: 227.044,
    y1: 8.18012,
    x2: 236.592,
    y2: 8.18012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_422_7358",
    x1: 215.178,
    y1: 14.3434,
    x2: 237.639,
    y2: 14.3434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_422_7358",
    x1: 193.703,
    y1: 13.8543,
    x2: 202.153,
    y2: 13.8543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_422_7358",
    x1: 191.853,
    y1: 17.45,
    x2: 223.415,
    y2: 17.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_422_7358",
    x1: 200.14,
    y1: 13.4672,
    x2: 203.77,
    y2: 13.4672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_422_7358",
    x1: 197.425,
    y1: 13.1821,
    x2: 200.496,
    y2: 13.1821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_422_7358",
    x1: 229.038,
    y1: 11.3075,
    x2: 237.651,
    y2: 11.3075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_422_7358",
    x1: 191.426,
    y1: 21.1376,
    x2: 198.025,
    y2: 21.1376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_422_7358",
    x1: 164.602,
    y1: 10.8491,
    x2: 185.457,
    y2: 10.8491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_422_7358",
    x1: 203.831,
    y1: 11.2158,
    x2: 224.676,
    y2: 11.2158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A57D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FBF2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F1DD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A67F25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_7358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 396,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLine);
export default __webpack_public_path__ + "static/media/star-line.d195223ab122d8c7de07fd4e81a60f17.svg";
export { ForwardRef as ReactComponent };